/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';

@Injectable(
  	{ providedIn: 'root' }
)

export class JwtService {

	constructor(private jwtHelper: JwtHelperService) {}

	public saveToken(token: string): void {
		localStorage.setItem('jwt', token);
	}

	public getToken(): string | null {
		return localStorage.getItem('jwt');
	}

	public clearToken(): void {
		localStorage.removeItem('jwt');
	}

	public isTokenExpired(): boolean {
		const token = this.getToken();
		return token ? this.jwtHelper.isTokenExpired(token) : true;
	}

	public isLoggedIn(): boolean {
		return !this.isTokenExpired();
	}
  
}